import {setElementInnerHTML} from '../ui_utils/DomUtils'

export class UIRoomCenterSettingsMaxPlayersView {
    container: HTMLDivElement
    private readonly maxPlayersInput: HTMLHeadingElement
    maxPlayersRightArrow: HTMLImageElement
    maxPlayersLeftArrow: HTMLImageElement
    maxPlayersDivBody: HTMLDivElement

    constructor(container: HTMLDivElement) {
        this.container = container
        this.maxPlayersInput = container.querySelector('#room_center_maxplayers_settings_input') as HTMLHeadingElement
        this.maxPlayersRightArrow = container.querySelector('#maxplayers_settings_right_arrow') as HTMLImageElement
        this.maxPlayersLeftArrow = container.querySelector('#maxplayers_settings_left_arrow') as HTMLImageElement
        this.maxPlayersDivBody = container.querySelector('#maxplayers_settings_body') as HTMLDivElement

        const maxPlayersInfo = document.getElementById('maxplayers_settings_speed_info') as HTMLImageElement
        maxPlayersInfo.hidden = true
    }

    setMaxPlayerCount(currentPlayerCount: number, gameModeMaxPlayerCount: number) {
        setElementInnerHTML(this.maxPlayersInput, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `${currentPlayerCount}/${gameModeMaxPlayerCount}`}})
    }
}
